import { render, staticRenderFns } from "./ArticleTeliaProjectScroller.vue?vue&type=template&id=81004b3a"
import script from "./ArticleTeliaProjectScroller.vue?vue&type=script&lang=ts"
export * from "./ArticleTeliaProjectScroller.vue?vue&type=script&lang=ts"
import style0 from "./ArticleTeliaProjectScroller.vue?vue&type=style&index=0&id=81004b3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports